import { APP_CONSTANTS } from "../../constants/AppConstants";
import { IProduct } from "../interfaces/IProduct";
import { IView } from "../interfaces/IView";
import { getMeta } from "../utils/utils";
import { httpApi } from "./http.api";

export const getViewData = (id: any, podId: any = 0): Promise<IView[]> => {
  return new Promise((resolve) => {
    httpApi
      .get<IView[]>(APP_CONSTANTS.view_api + id + "/" + podId)
      .then(async ({ data }) => {
        let newData = [];
        for (let index = 0; index < data.length; index++) {
          const img: any = await getMeta(data[index].img);
          data[index].productImageWidth = img.naturalWidth;
          data[index].productImageHeight = img.naturalHeight;
          newData.push(data[index]);
        }

        resolve(newData);
      });
  });
};

export const getProductColors = (): Promise<IProduct> =>
  httpApi
    .get<IProduct>(`${window.location.origin}/window.log`)
    .then(({ data }) => data);

export const getProductDetails = (id: any): Promise<any> => {
  return new Promise((resolve) => {
    httpApi
      .get<IProduct>(APP_CONSTANTS.product_detail_api + id)
      .then(({ data }) => {
        resolve(data);
      });
  });
};

export const updateDesign = (podId: any, data: any): Promise<any> => {
  return new Promise((resolve) => {
    httpApi.put(`pod_products/${podId}/design`, data).then(({ data }) => {
      resolve(data);
    });
  });
};

export const removeBackgroundAPI = (imageUrl: any): Promise<any> => {
  return new Promise((resolve) => {
    httpApi
      .post(APP_CONSTANTS.removeBackgroundNew, { path: imageUrl })
      .then(({ data }) => {
        resolve(data);
      });
  });
};

export const getDesignPDF = (designId: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    httpApi
      .get(`output/${designId}`, {
        responseType: "arraybuffer", // Ensures binary response
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
